import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, resolveDynamicComponent as _resolveDynamicComponent } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = { class: "h-screen flex flex-col bg-gray-lp-1000" }
const _hoisted_2 = {
  key: 0,
  class: "border-b border-gray-lp-2100 pt-3 bg-white"
}
const _hoisted_3 = { class: "px-6 py-3 flex items-center gap-x-4 border-b border-gray-lp-2100 bg-white" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 cursor-pointer",
  alt: "back"
}, null, -1)
const _hoisted_5 = { class: "text-xl text-black-lp-300 font-semibold" }
const _hoisted_6 = {
  class: "flex-grow p-4 flex flex-col",
  style: {"height":"calc(calc(100vh / var(--viewport-scale)) - 170px)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tabs = _resolveComponent("Tabs")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.isSidebarAndBreadcrumbV2)
      ? (_openBlock(), _createBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("button", {
        id: "button_back_history_hanging",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (
          _ctx.$router.push({
            path: '/dashboard',
            query: { activeMenu: 'hanging-bkd' }
          })
        ))
      }, [
        _hoisted_4
      ]),
      _createVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('dashboard.hanging.historyBkdTitle')), 1)
    ]),
    _createVNode(_component_Tabs, {
      modelValue: _ctx.activeMenu,
      "onUpdate:modelValue": _ctx.onChangeTabs,
      data: _ctx.tabs,
      rounded: false,
      marginTop: 0,
      marginBottom: 0,
      titleSize: 16,
      gap: 8,
      class: "px-4 flex",
      customClass: "px-4"
    }, null, 8, ["modelValue", "onUpdate:modelValue", "data"]),
    _createVNode("div", _hoisted_6, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeTabComponent)))
    ])
  ]))
}